import React, { useState } from "react";
import "./Daf.css";
import {
  Accordion,
  AccordionHeading,
  Col,
  Link,
  Row,
  Tab,
  TabList,
  Typography,
} from "@visa/vds";
import AccordionBody from "@visa/vds/accordion-body";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionTitle from "@visa/vds/accordion-title";

import FlowPic1 from "../../_imgs/daf/new_daf_flow/DAF Pg - Flow 1 -DAF Flow-UPDATED_1920.png";
import FlowPic2 from "../../_imgs/daf/new_daf_flow/DAF Pg - Flow 2 -Initial DAF Flow-UPDATED_1920.png";
import FlowPic3 from "../../_imgs/daf/new_daf_flow/DAF Pg - Flow 3 -3DS Flow-UPDATED_1920.png";

import DAFGraphic from "../../_imgs/daf/(C) DAF Graphic - Copy.png";
import { useHistory } from "react-router-dom";
import { LIBRARY } from "../../_constants/PageRoutes";
import MCSGridRevert from "../../components/MCSGridRevert";

function Daf() {
  const history = useHistory();
  const click3Handler = () => history.push(LIBRARY);
  const [selectedTab, setSelectedTab] = useState(0);
  const defaultExpandedPanels = [selectedTab];

  return (
      <MCSGridRevert>
        <Row>
          <Col className="vss-header vss-header-large-gap">
            <Typography tag="h1" variant="headline" className="daf-header">
              Digital Authentication Framework
            </Typography>
          </Col>
        </Row>
        <Row className="daf-description">
          <Col xs={12} sm={8} md={12} lg={5} xl={5}>
            <Typography
              tag="h1"
              variant="headline"
              style={{ color: "#1434cb" }}
            >
              Working to raise the confidence in authorization decisions
            </Typography>
            <Typography variant="body" className="vss-text-body-large">
              The Digital Authentication Framework (DAF) builds upon the proven
              success of our authentication and tokenization services by
              defining key performance criteria that are designed to create a
              consistent and frictionless user experience. In addition, DAF
              helps provide merchants with fraud dispute protection when the
              criteria for qualified authenticated purchase transactions are
              met.
            </Typography>
            <Typography variant="body" className="vss-text-body-large">
              Underpinning DAF will be a set of performance requirements for
              merchants, token requestors, and issuers, designed to ensure
              solutions are deployed in an effective manner, provide a balanced
              value proposition across all constituents, and help to create a
              positive user experience.
            </Typography>
          </Col>
          <div className="separator"></div>
          <Col xs={12} sm={8} md={12} lg={5} xl={5}>
            <Typography
              tag="h1"
              variant="headline"
              style={{ color: "#1434cb" }}
            >
              Potential Benefits
            </Typography>
            <div className="potential-description">
              <Typography className="benefit-title">
                Alleviate Fraud Disputes
              </Typography>
              <Typography variant="body" className="vss-text-body-large">
                DAF expands the Visa Secure to provide fraud dispute protection
                on card-not-present transactions.
              </Typography>
              <Typography className="benefit-title">Reduce Fraud</Typography>
              <Typography variant="body" className="vss-text-body-large">
                DAF transactions provide enhanced risk data to increase
                confidence, facilitate better issuer risk decisioning, and
                improve fraud outcomes.
              </Typography>
              <Typography className="benefit-title">
                Decrease Cart Abandonment
              </Typography>
              <Typography variant="body" className="vss-text-body-large">
                DAF is designed to reduce checkout friction and lower cart
                abandonment by limiting the number of step-up authentication
                events.
              </Typography>
              <Typography className="benefit-title">
                Improve Authorization Rates
              </Typography>
              <Typography variant="body" className="vss-text-body-large">
                DAF improves authorization rates by facilitating additional
                information to the issuer for greater transaction decision making.
              </Typography>
            </div>
          </Col>
        </Row>
        <Row className="daf-flow-description">
          <Col>
            <Typography
              tag="h1"
              variant="headline"
              style={{ color: "#1434cb" }}
            >
              DAF Flow
            </Typography>
            <Typography variant="body" className="vss-text-body-large">
              When merchants authenticate with the Visa Secure DAF extension,
              returning cardholders do not need to complete a challenge for
              authentication approval. DAF accomplishes this experience by
              requiring a completed authentication challenge on the first DAF
              transaction. This proves to Visa Issuers that the enhanced data
              represents the legitimate cardholder. On future transactions, the
              Issuer can safely authenticate the cardholder in a frictionless
              manner. DAF eligible transactions support multiple use cases to
              help streamline authentication at checkout, regardless of device.
            </Typography>
            <Typography variant="body" className="vss-text-body-large">
              Click the different transaction flows to view how DAF optimizes
              authentication.
            </Typography>
          </Col>
        </Row>
        <div className="tabs">
          <Row>
            <TabList selectedTab={selectedTab}>
              <Tab
                className="tab-header"
                onClick={(e, k) => setSelectedTab(k)}
                aria-controls="potential-merchant-benefits"
              >
                DAF Transaction
              </Tab>
              <Tab
                className="tab-header"
                onClick={(e, k) => setSelectedTab(k)}
                aria-controls="potential-issuer-benefits"
              >
                Initial DAF Transaction
              </Tab>
              <Tab
                className="tab-header"
                onClick={(e, k) => setSelectedTab(k)}
                aria-controls="potential-issuer-benefits"
              >
                Standard 3DS Transaction
              </Tab>
            </TabList>
          </Row>
          <div
            className="daf-tab-panel"
            hidden={selectedTab === 0 ? undefined : true}
            role="tabpanel"
          >
            <img
              src={FlowPic1}
              alt="Auth"
              className="visa-secure-process-pic"
            />
          </div>
          <div
            className="daf-tab-panel"
            hidden={selectedTab === 1 ? undefined : true}
            role="tabpanel"
          >
            <img
              src={FlowPic2}
              alt="Auth"
              className="visa-secure-process-pic"
            />
          </div>
          <div
            className="daf-tab-panel"
            hidden={selectedTab === 2 ? undefined : true}
          >
            <img
              src={FlowPic3}
              alt="Auth"
              className="visa-secure-process-pic"
            />
          </div>
        </div>
        <Row id="accordians">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Accordion defaultExpandedId={defaultExpandedPanels}>
              <AccordionItem>
                <AccordionHeading>
                  <AccordionTitle className="accordion-title">
                    DAF Transaction
                  </AccordionTitle>
                </AccordionHeading>
                <AccordionBody>
                  <img
                    src={FlowPic3}
                    alt="Auth"
                    className="visa-secure-process-pic"
                  />
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeading>
                  <AccordionTitle className="accordion-title">
                    Initial DAF Transaction
                  </AccordionTitle>
                </AccordionHeading>
                <AccordionBody>
                  <img
                    src={FlowPic2}
                    alt="Auth"
                    className="visa-secure-process-pic"
                  />
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeading>
                  <AccordionTitle className="accordion-title">
                    Standard 3DS Transaction
                  </AccordionTitle>
                </AccordionHeading>
                <AccordionBody>
                  <img
                    src={FlowPic1}
                    alt="Auth"
                    className="visa-secure-process-pic"
                  />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </Col>
        </Row>
        <Row className="daf-data-requirement">
          <Col
            xs={4}
            md={8}
            lg={7}
            xl={8}
            style={{ zIndex: 1, background: "" }}
          >
            <Typography variant="body" className="vss-text-body-large">
              <Typography
                tag="h1"
                variant="headline"
                style={{ color: "#1434cb" }}
              >
                DAF Data Requirements
              </Typography>
              <Typography
                className="vss-text-body-large vss-text-body-justify"
                variant="body"
              >
                DAF EMV 3DS requires the following information (alongside the
                Visa Secure for EMV 3DS data elements), to facilitate a better
                risk analysis for participating transactions.
              </Typography>

              <ul style={{ marginTop: "20px" }}>
                <li>
                  Visa Merchant ID (assigned by Visa during the registration
                  process)
                </li>
                <li>Cardholder Billing and Contact Information</li>
                <li>IP Address</li>
              </ul>
            </Typography>
          </Col>
          <Col xs={4} md={4} lg={5} xl={4} className="col-vss-image">
            <div className="daf-ilustration-image-panel daf-ilustration-visa-secure-home">
              <img src={DAFGraphic} alt="Visa Secure with EMV 3DS"/>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            <Typography className="vss-learn-more">
              Looking to learn more? Log in and visit the{" "}
              <Link
                onClick={click3Handler}
                inline
                className="vss-link-big"
                aria-label="VSS Library"
              >
                VSS Library
              </Link>{" "}
              to access additional DAF documentation.
            </Typography>
          </Col>
        </Row>
      </MCSGridRevert>
  );
}

export default Daf;
